// extracted by mini-css-extract-plugin
module.exports = {"container":"_82e3db2ea0--container--k62Jt","desktop":"_82e3db2ea0--desktop--wKA5P","tablet":"_82e3db2ea0--tablet--U21Xg","phone":"_82e3db2ea0--phone--TXHGD"};